/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetFormSectionModel } from './PetFormSectionModel';
import {
    PetFormSectionModelFromJSON,
    PetFormSectionModelFromJSONTyped,
    PetFormSectionModelToJSON,
} from './PetFormSectionModel';
import type { PetTypeModel } from './PetTypeModel';
import {
    PetTypeModelFromJSON,
    PetTypeModelFromJSONTyped,
    PetTypeModelToJSON,
} from './PetTypeModel';

/**
 * 
 * @export
 * @interface PetFormConfigurationModel
 */
export interface PetFormConfigurationModel {
    /**
     * 
     * @type {PetTypeModel}
     * @memberof PetFormConfigurationModel
     */
    petType: PetTypeModel;
    /**
     * 
     * @type {Array<PetFormSectionModel>}
     * @memberof PetFormConfigurationModel
     */
    sections: Array<PetFormSectionModel>;
}

/**
 * Check if a given object implements the PetFormConfigurationModel interface.
 */
export function instanceOfPetFormConfigurationModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "petType" in value;
    isInstance = isInstance && "sections" in value;

    return isInstance;
}

export function PetFormConfigurationModelFromJSON(json: any): PetFormConfigurationModel {
    return PetFormConfigurationModelFromJSONTyped(json, false);
}

export function PetFormConfigurationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormConfigurationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'petType': PetTypeModelFromJSON(json['petType']),
        'sections': ((json['sections'] as Array<any>).map(PetFormSectionModelFromJSON)),
    };
}

export function PetFormConfigurationModelToJSON(value?: PetFormConfigurationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'petType': PetTypeModelToJSON(value.petType),
        'sections': ((value.sections as Array<any>).map(PetFormSectionModelToJSON)),
    };
}

